/** @format */

/**
 * Ejecuta tareas con concurrencia limitada, informando el avance.
 * Se usa para los lotes del gestor de OT: la Cloud Function que genera los PDF
 * renderiza cada pagina en un navegador headless, asi que lanzarlas todas a la
 * vez la satura y empiezan a fallar.
 */
export const ejecutarEnLotes = async (items, tarea, opciones = {}) => {
	const { concurrencia = 2, onProgreso = () => {}, cancelado = () => false } = opciones;
	const resultados = [];
	let siguiente = 0;
	let hechas = 0;

	const trabajador = async () => {
		while (siguiente < items.length) {
			if (cancelado()) return;
			const indice = siguiente++;
			try {
				const valor = await tarea(items[indice], indice);
				resultados[indice] = { ok: true, item: items[indice], valor };
			} catch (error) {
				resultados[indice] = { ok: false, item: items[indice], error };
			}
			hechas += 1;
			onProgreso(hechas, items.length, resultados[indice]);
		}
	};

	await Promise.all(
		Array.from({ length: Math.min(concurrencia, items.length) }, () => trabajador())
	);

	return resultados.filter(Boolean);
};
